<div class="c-wysiwyg">
  <p>You can now edit any of these details or just carry on where you left off .</p>

</div>
<recap
  [caseId]="incoming_case_id"
  (stageChanging)="gotoStage($event)"
doAddressMatch="false"></recap>
@if (isDip === true && CurrentStep >= 108) {
  <div class="row" >
    <div class="col-12">
      <button class="c-button c-button--inverse float-right" type="button" (click)="handleGetDIPCertificate()">
        Your offer details
        <svg class="c-button__icon c-button__icon--right icon-document" focusable="false" xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 21 25">
          <path fill="none" stroke="#fff" stroke-miterlimit="10" d="M.5 23.37V.5h18.75l1.25 1.26v18.67l-4.04 4.07H1.49L.5 23.37z" />
          <path fill="none" stroke="#fff" stroke-miterlimit="10" d="M14.33 23.4v-5.65h5.03M4.22 4.74h12.56M4.22 8.63h12.56M4.22 12.65h12.56" />
        </svg>
      </button>
    </div>
  </div>
}
<together-auction-dip-stage-select
  [disabled]="IsLoading"
  [forward_title]="'Complete your details'"
  [show_action]="false"
  [show_forward]="true"
  [show_backward]="false"
  [show_backward_icon]="false"
  (on_forward)="onForwardClicked($event)">
</together-auction-dip-stage-select>

<together-auction-dip-loading [is_loading]="IsLoading"></together-auction-dip-loading>
